import { APP_LANGUAGES } from '~/shared/constants/languages';
import { Model } from '~/shared/service/service.base';

const TR_LANGUAGES = APP_LANGUAGES.filter(lang => lang !== 'en');

export type Language = (typeof TR_LANGUAGES)[number];

export type Translation = {
	lang: Language;
	name: string | null;
};

export type Translations = {
	[lang in Language]?: string;
};

@Model()
export class TranslationModel {
	readonly languages = TR_LANGUAGES.sort((a, b) => a.localeCompare(b));

	getTranslationsFromRow<T extends Translations>(row: T): Translation[] {
		const rv = [] as Translation[];
		for (const lang of this.languages) {
			if (lang in row) rv.push({ lang, name: row[lang] || null });
		}
		return rv;
	}

	addTranslationsToExample<T extends Translations>(example: T) {
		for (const lang of this.languages) {
			example[lang] = `Example (${lang})`;
		}
	}
}
